import PropTypes from "prop-types";
import { Field, Dropdown, Option } from "@fluentui/react-components";
import { URL_SCHEMES } from "../../../../util/general-helpers";

const FieldUrlOptions = ({ fieldValues, setFieldValues, disabled }) => {
  const selectedScheme = fieldValues.LookupValues?.[0] || "";

  const handleSchemeChange = (e, data) => {
    const newLookup = [data.optionValue];
    setFieldValues({
      ...fieldValues,
      LookupValues: newLookup,
      touched: true,
    });
  };

  const showValidationError = !selectedScheme && fieldValues.touched;

  return (
    <div style={{ marginTop: "16px" }}>
      <Field
        label="URI Scheme Type"
        required
        validationMessage={showValidationError ? "Required value" : ""}
        size="medium"
      >
        <Dropdown
          placeholder="Select a scheme"
          selectedOptions={selectedScheme ? [selectedScheme] : []}
          value={selectedScheme}
          onOptionSelect={handleSchemeChange}
          disabled={disabled}
        >
          {URL_SCHEMES.map((scheme) => (
            <Option key={scheme} value={scheme}>
              {scheme}
            </Option>
          ))}
        </Dropdown>
      </Field>
    </div>
  );
};

FieldUrlOptions.propTypes = {
  fieldValues: PropTypes.shape({
    LookupValues: PropTypes.arrayOf(PropTypes.string),
    touched: PropTypes.bool,
  }).isRequired,
  setFieldValues: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

FieldUrlOptions.defaultProps = {
  disabled: false,
};

export default FieldUrlOptions;